import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { QUERY_KEYS } from "../constants/reactQueryKeyConsts";

export const useGetInternalTrackerData = ({body, config}) => {
    return useQuery({
      queryKey: [QUERY_KEYS.INTERNALTRACKERGETDATA],
      queryFn: () => {
        return axios
          .get(`${process.env.REACT_APP_API_URI}InternalTracker?from=${body.fromDate}&to=${body.toDate}`, config)
          .then((res) => {
            //console.log("res is", res);
            if(res?.data?.data){
              return res.data.data
            }
            if(res.data.error){
              throw new Error(res.data.message)
            }
            return []
          });
      },
      refetchOnWindowFocus: false,
    });
  }